import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { FormUtils } from 'src/app/utils/FormUtils';
import {
  prev_modify_referent_form_keys,
  prev_modify_referent_form_template,
  prev_modify_referent_form_validators,
} from './modify-referent-employer.constants';
import { EModalOutput } from 'src/app/modules/shared/components/basic-modal/basic-modal.constants';

@Component({
  selector: 'app-modify-referent-employer',
  templateUrl: './modify-referent-employer.component.html',
  styleUrl: './modify-referent-employer.component.scss',
})
export class ModifyReferentEmployerComponent implements OnInit {
  public modifyReferentForm: FormGroup;
  public modifyReferentFormKeys: IFormKey[];

  constructor(
    private dialogRef: MatDialogRef<ModifyReferentEmployerComponent>,
    @Inject(MAT_DIALOG_DATA) private modalData,
  ) {}

  ngOnInit(): void {
    this.modifyReferentForm = FormUtils.initFormGroupFromTemplate(
      prev_modify_referent_form_template,
      prev_modify_referent_form_validators
    );
    this.modifyReferentFormKeys = CommonUtils.assign(
      prev_modify_referent_form_keys
    );

    const employerCodeControl = this.modifyReferentForm.get('employerCode');
    employerCodeControl.setValue(this.modalData.employerCode);
    employerCodeControl.disable();
  }

  public onConfirmSelection() {
    this.dialogRef.close({
      data: this.modifyReferentForm.value,
      command: EModalOutput.CONFIRM,
    });
  }

  public onCancelSelection() {
    this.dialogRef.close();
  }
}
